import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import AgGridTable from "../utilities/AgGridTable";
import { Button, Tooltip, Select as MuiSelect, TextField, FormControl, MenuItem, Stack, Switch, IconButton, Dialog, DialogContent, AppBar, Toolbar, Typography, DialogActions, } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import Select from "react-select";
import CustomDatePicker from "../utilities/CustomDatePicker";
import customStyles from "app/shared-components/SelectCustomStyle";
import moment from "moment";
import ViewProformaInvoiceData from "./ViewProformaInvoiceData";
import { Link, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import EditCreatedProformaInvoice from "./EditCreatedProformaInvoice";

const ProformaInvoice = () => {
    const gridRef = useRef();
    const [error, setError] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [customerOption, setCustomerOption] = useState([]);
    const [selectedSize, setSelectedSize] = useState(10);
    const [successMsg, setSuccessMsg] = useState();
    const [snackState, setSnackState] = useState(false);
    const [fromError, setFromError] = useState();
    const [toError, setToError] = useState();
    const currentDate = new Date();
    const [toDate, setToDate] = useState(moment('12-31-'+currentDate.getFullYear()).format('YYYY-MM-DD'));
    const [fromDate, setFromDate] = useState(moment('01-01-'+currentDate.getFullYear()).format('YYYY-MM-DD'));
    const [showEditPI, setShowEditPI] = useState(false);
    const [formPrintOpen, setFormPrintOpen] = useState(false);
    const [editPIData, setEditPIData] = useState();
    const [customerNum, setCustomerNum] = useState();
    const [viewPIData, setViewPIData] = useState();
    const [selectedPrintOpt, setSelectedPrintOpt] = useState();
    const [showViewPI, setShowViewPI] = useState(false);
    const [plan, setPlan] = useState('Loading');
    const [active, setActive] = useState(false);
    const [palnOptions, setPlanOptions] = useState([
        { label: "Actual Plan", value: "Actual" },
        { label: "Loading Plan", value: "Loading" }
    ]);
    const [gridApi, setGridApi] = useState();
    const [rowData, setRowData] = useState()
    const [expandRowData, setExpandRowData] = useState("collapse");
    const PIurl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ProformaInvoice}`;

    const checkFinanced = (props) => {
        return (props.value || !props.value) && <Switch size="small" checked={props.value} />
    }

    const handleViewProformaRender = (props) => {
        return <IconButton size="small" onClick={() => { setShowViewPI(true); setViewPIData(props.data) }} sx={{ p: 0 }}>
            <FuseSvgIcon size={16}>heroicons-solid:eye</FuseSvgIcon>
        </IconButton>
    }
    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{props?.value && new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };

    const [columnDefs, setColumnDefs] = useState([
        {
            field: 'piNumber', headerName: 'PI NO', minWidth: 150, checkboxSelection: false, headerCheckboxSelection: false,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            cellRenderer: 'agGroupCellRenderer',
            rowSpan: function (params) {
                if (params?.data?.piNumber !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'piDate', headerName: 'PI Date', minWidth: 150,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.piDate !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'orderCategory', headerName: 'Order Category', minWidth: 150,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
        },
        {
            field: 'custNum', headerName: 'Customer', minWidth: 150,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
        },
        {
            field: 'custName', headerName: 'Name', minWidth: 150,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
        },
        {
            field: 'balanceUnpaid', headerName: 'PI Value', minWidth: 150, cellRenderer: renderCurrency,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
        },
        {
            field: 'actualContainerNo', headerName: 'Container No', minWidth: 230,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.actualContainerNo !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'internalContainerNo', headerName: 'INTL Container No', minWidth: 230,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.internalContainerNo !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'paymentCutoffDate', headerName: 'Payment Cut Off Date', minWidth: 250,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.paymentCutoffDate !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'advPaymentRcvdDate', headerName: 'ADV Pay RCVD Date', minWidth: 230,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.advPaymentRcvdDate !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'loadingPlanDate', headerName: 'Loading Plan Date', minWidth: 230,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.loadingPlanDate !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'loadingPlanWeek', headerName: 'Loading Plan Week', minWidth: 230,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.loadingPlanWeek !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'actualLoadingDate', headerName: 'Actual Loading Date', minWidth: 250,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.actualLoadingDate !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'actualLoadingWeek', headerName: 'Actual Loading Week', minWidth: 250,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.actualLoadingWeek !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'paymentTerm', headerName: 'Payment Term', minWidth: 230,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
        },
        {
            field: 'paymentDescription', headerName: 'Payment Description', minWidth: 250,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
        },
        {
            field: 'remarks', headerName: 'Remarks', minWidth: 150,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.remarks !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'isFinanced', headerName: 'Financed', minWidth: 150, cellRenderer: checkFinanced,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.isFinanced !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'view', headerName: 'View/Edit', minWidth: 150, cellRenderer: handleViewProformaRender,
            cellClassRules: {
                'proforma-yellow-font': params => (params?.data?.indicator === 3),
                'proforma-green-font': params => (params?.data?.indicator === 2),
                'proforma-red-font': params => (params?.data?.indicator === 1),
            },
            rowSpan: function (params) {
                if (params?.data?.view !== undefined) {
                    return params?.data?.piNumbersCount;
                } else {
                    return 1;
                }
            }
        },

    ])

    const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                columnDefs: [
                    { field: 'custName' },
                    { field: 'vendorName', },
                    { field: 'commissionName' },
                    { field: 'abNumber' },
                    { field: 'orderCategory' },
                    { field: 'paymentCutoffDate' },
                    { field: 'advPaymentRcvdDate' },
                    { field: 'internalContainerNo' },
                    { field: 'actualContainerNo' },
                    { field: 'loadingPlanDate' },
                    { field: 'loadingPlanWeek' },
                    { field: 'actualLoadingDate' },
                    { field: 'actualLoadingWeek' },
                    { field: 'paymentTerm' },
                    { field: 'paymentDescription' },
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: function (params) {
                params.successCallback(params.data.detailData);
            },
        };
    }, []);

    const handleCustomerChange = (e) => {
        setCustomerNum(e?.id)
    }

    const handleExpandPI = () => {
        if (expandRowData === 'expand') {
            setTimeout(function () {
                if (gridRef.current) {
                    gridRef.current.api.forEachNode(function (node) {
                        node.setExpanded(true);
                    });
                }
            }, 0);
        } else {
            setTimeout(function () {
                if (gridRef.current) {
                    gridRef.current.api.forEachNode(function (node) {
                        node.setExpanded(false);
                    });
                }
            }, 0);
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        loadProformaInvoiceData();
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }


    const handleSubmit = () => {

    }

    const handleEditPI = () => {
        setShowEditPI(true);
        setEditPIData(selectedRows[0])
    }

    const handleViewPI = () => {
        setShowViewPI(true);
        setViewPIData(selectedRows[0])
    }

    const handlePrintPI = () => {
        setFormPrintOpen(true)
    }

    const handleReleaseProd = async () => {
        const selectedId = selectedRows.length > 0 ? selectedRows[0].piNumber : ''
        try {
            const list = await OAuthService.putData(PIurl + '/sendpiforreleaseapproval', { "piNumbers": [selectedId] })

            if (list?.data) {
                setSuccessMsg(list?.data || "Proforma Invoice send release for Production")
                setSnackState(true)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const handleRequestApproval = async () => {

        const selectedId = selectedRows.length > 0 ? selectedRows[0].piNumber : ''
        try {
            const list = await OAuthService.putData(PIurl + '/sendpiforbookingapproval', { "piNumbers": [selectedId] })

            if (list?.data) {
                setSuccessMsg(list?.data || "Proforma Invoice send request for Approval")
                setSnackState(true)
            }
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    const handleActiveChange = (e) => {
        setActive(e.target.checked);
    };


    const onPageSizeChanged = useCallback((e) => {
        setSelectedSize(e.target.value);
        var value = e.target.value;
        gridRef.current.api.paginationSetPageSize(value);
    }, []);

    const handleChangeplan = (value) => {
        setPlan(value.value)
    }

    // const handlechangecompany = (event) => {
    //     setCompany(event.target.value)
    //     loadProformaInvoiceData()
    // }

    const handleFromDateChange = (value) => {
        setFromDate(value === null ? null : moment(value).format('YYYY-MM-DD'));
        value && setToDate(null);
    }

    const handleToDateChange = async (value) => {
        const endDate = value === null ? null : moment(value).format('YYYY-MM-DD');
        setToDate(endDate);
        (!fromDate && endDate) ? setFromError('Please select from date ') : setFromError('');
    }

    useEffect(() => {
        loadProformaInvoiceData()
    }, [plan, fromDate, toDate, customerNum])

    const loadProformaInvoiceData = async () => {
        if (token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR') || token?.scope?.includes('ROLE_MD') || token?.scope?.includes('ROLE_SOPDIR')) {
            let jsonObj = {
                fromDt: fromDate,
                toDt: toDate,
                custNum: customerNum
            }
            if (plan) {
                if (plan === 'Loading') {
                    jsonObj = { ...jsonObj, loadingPlan: true }
                } else {
                    jsonObj = { ...jsonObj, loadingPlan: false }
                }
            } else {
                delete jsonObj.loadingPlan
            }
            const list = await OAuthService.addData(PIurl + '/getproformabasedoncriteria', jsonObj)

            if (list?.data) {
                const allLists = list?.data.map((data) => {
                    data.detailData = [...data.projectOrdersList, ...data.retailOrdersList]
                    return data;
                })
                setRowData(list?.data)
            } else {
                setRowData([])
            }

        } else {
            setError("You don't have privileges to view Proforma Invoice")
        }
    }

    useEffect(() => {
        handleExpandPI()
    }, [expandRowData])

    const proformaInputFields = () => {
        return <>
            {(token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR') || token?.scope?.includes('ROLE_MD') || token?.scope?.includes('ROLE_SOPDIR')) &&
                <>
                    <Tooltip title={"ADD Proforma Invoice"}>
                        <Link to={"/addProformaInvoice"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                            // onClick={handleSubmit}
                            >
                                <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                            </Button>
                        </Link>
                    </Tooltip>

                    {selectedRows && selectedRows.length > 0 &&
                        <>
                            <Tooltip title={"Edit Proforma Invoice"}>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    style={{ marginLeft: "4px" }}
                                    onClick={handleEditPI}
                                >
                                    <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
                                </Button>
                            </Tooltip>


                            <Tooltip title={"View Proforma Invoice"}>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    style={{ marginLeft: "4px" }}
                                    onClick={handleViewPI}
                                >
                                    <FuseSvgIcon>heroicons-solid:eye</FuseSvgIcon>
                                </Button>
                            </Tooltip>
                        </>
                    }
                    {(expandRowData === "collapse") ?
                        < Tooltip title={"Expand Proforma Invoice"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={() => setExpandRowData('expand')}
                            >
                                <FuseSvgIcon>material-outline:unfold_more</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                        :

                        <Tooltip title={"Collapse Proforma Invoice"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={() => { setExpandRowData('collapse'); }}
                            >
                                <FuseSvgIcon>material-outline:unfold_less</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                    }
                    {selectedRows && selectedRows.length > 0 && <Tooltip title={"Print Proforma Invoice"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handlePrintPI}
                        >
                            <FuseSvgIcon>heroicons-outline:printer</FuseSvgIcon>
                        </Button>
                    </Tooltip>}

                    {selectedRows && selectedRows.length > 0 && <Tooltip title={"Request for Approval"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleRequestApproval}
                        >
                            <FuseSvgIcon>heroicons-outline:check-circle</FuseSvgIcon>
                        </Button>
                    </Tooltip>}

                    {selectedRows && selectedRows.length > 0 && <Tooltip title={"Release for Prod"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleReleaseProd}
                        >
                            <FuseSvgIcon>material-outline:new_releases</FuseSvgIcon>
                        </Button>
                    </Tooltip>}
                </>
            }
        </>
    }

    const handleEditForm = (status) => {
        setShowEditPI(status);
    }
    const handleViewForm = (status) => {
        setShowViewPI(status);
    }

    useEffect(() => {
        handleEditForm();
        handleViewForm();
        handleSuccessMsg();
        handleError();

        const companies = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByActive?active=true`;
    
            const list = await OAuthService.getList(url);
    
            const listResult = list?.data?._embedded?.companies.map((value) => {
              return {
                label: value._links.company.href.split("/").pop() + ' - ' + value.name,
                value: value.name,
                id: value._links.company.href.split("/").pop(),
              };
            });
    
            setCustomerOption(listResult);
        }
        companies()
    }, []);

    const handleError = (msg) => {
        setError(msg)
    }
    const handleSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
            setSnackState(true)
        } else {
            setSnackState(false)
        }
    }

    const handlePrintPIOption = async () => {
        if (selectedRows && selectedRows.length > 0) {
            if (selectedPrintOpt === 'Print') {
                const piNum = selectedRows[0].piNumber;
                const proforma = await OAuthService.getPdf(
                    PIurl + `/previewPiInfo/${piNum}/false/false`
                );

                const file = new Blob([proforma?.data], {
                    type: "application/pdf",
                });

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL, '_blank');

            } else if (selectedPrintOpt === 'PrintStamp') {
                const piNum = selectedRows[0].piNumber;
                const proforma = await OAuthService.getPdf(
                    PIurl + `/previewPiInfo/${piNum}/true/false`
                );

                const file = new Blob([proforma?.data], {
                    type: "application/pdf",
                });

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL, '_blank');

            } else if (selectedPrintOpt === 'PrintSignStamp') {
                const piNum = selectedRows[0].piNumber;
                const proforma = await OAuthService.getPdf(
                    PIurl + `/previewPiInfo/${piNum}/true/true`
                );

                const file = new Blob([proforma?.data], {
                    type: "application/pdf",
                });

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL, '_blank');
            }
        }
    }

    const handleSelectedPrint = async (e) => {
        const selectedoption = e.value;
        setSelectedPrintOpt(e.value)       
    }

    return (
        <>
            <ListPageHeader
                pageName={"Proforma Invoice"}
                componentName="Proforma Invoice"
                headerInputFields={proformaInputFields()}
                gridRef={gridRef}
                successMsg={successMsg}
                snackState={snackState}
                showPaginationDropdown={false}
                error={error}
            />

            <Stack direction={'row'} className="mb-10 md:px-16 self-end ">
                <div className="flex flex-row">
                    <div className="flex flex-row justify-between items-baseline">
                        {(token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR') || token?.scope?.includes('ROLE_MD') || token?.scope?.includes('ROLE_SOPDIR')) &&
                            <>
                             <Stack className="ml-10">
                                    <label className="min-w-fit">Customer </label>
                                    <div className="grid">
                                        <Select
                                            name="Customer"
                                            onChange={handleCustomerChange}
                                            options={customerOption}
                                            styles={customStyles()}
                                        />
                                    </div>
                                </Stack>
                                {/* <FormControl className={"flex"} size="small">
                                    <label className="pt-12 min-w-fit">Page Size</label>
                                    <MuiSelect onChange={onPageSizeChanged} className='ml-5 h-fit min-w-[150px]' value={selectedSize} id="page-size"
                                        // native={true}
                                        inputProps={{
                                            sx: { 'padding': '10px' },
                                        }}
                                    >
                                        <MenuItem value="10">10</MenuItem>
                                        <MenuItem value="20">20</MenuItem>
                                        <MenuItem value="50">50</MenuItem>
                                        <MenuItem value="100">100</MenuItem>
                                    </MuiSelect>
                                </FormControl> */}

                                {/* <Stack className="ml-10">
                                    <label className="pt-12 min-w-fit">Company</label>
                                    <TextField
                                        name='company'
                                        value={company}
                                        onChange={handlechangecompany}
                                        inputProps={{
                                            sx: { 'padding': '10px' },
                                        }}
                                    />
                                </Stack> */}

                                <Stack className="ml-10">
                                    <label className="pt-12 min-w-fit">Plan</label>
                                    <Select
                                        name="vouchertype"
                                        className=" min-w-[150px]"
                                        // className="w-[85px] h-[20px]"
                                        value={(plan && palnOptions.length > 0) && palnOptions.filter((list) => list.value === plan)}
                                        onChange={handleChangeplan}
                                        options={palnOptions}
                                        styles={customStyles('', '', '0px')}
                                    />
                                </Stack>
                                <Stack className="ml-10">
                                    <label className="min-w-fit">From </label>
                                    <div className="grid">
                                        <CustomDatePicker
                                            className="w-[150px] h-[20px]"
                                            format={'dd-MM-yyyy'}
                                            name={'fromDate'}
                                            value={fromDate}
                                            handleChange={handleFromDateChange}
                                            views={['year', 'month', 'day']}
                                            componentsProps={{
                                                actionBar: { actions: ["clear"] },
                                            }}
                                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                                            }} {...params} sx={{
                                                backgroundColor: props.viewData && '#8080800f'
                                            }} />}
                                        />
                                        <p className="text-red">{(fromError && !fromDate) && fromError}</p>
                                    </div>
                                </Stack>
                                <Stack className="ml-10">
                                    <label className="min-w-fit">To </label>
                                    <div className="grid">
                                        <CustomDatePicker
                                            className="w-[150px] h-[20px]"
                                            format={'dd-MM-yyyy'}
                                            name={'toDate'}
                                            value={toDate}
                                            views={['year', 'month', 'day']}
                                            minDate={new Date(fromDate).setDate((new Date(new Date(fromDate).getTime())).getDate())}
                                            handleChange={handleToDateChange}
                                            componentsProps={{
                                                actionBar: { actions: ["clear"] },
                                            }}
                                            renderInput={(params) => <TextField size="small" InputLabelProps={{
                                            }} {...params} sx={{
                                                backgroundColor: props.viewData && '#8080800f'
                                            }} />}
                                        />
                                        <p className="text-red">{(toError && !toDate) && toError}</p>
                                    </div>
                                </Stack>
                            </>
                        }
                    </div>
                </div>
            </Stack>

            <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRef}
                onSelectionChanged={onSelectionChanged}
                groupCheckBox={false}
                suppressRowTransform={true}
                rowSelection={'single'}
                editable={false}
                masterDetail={true}
                detailCellRendererParams={detailCellRendererParams}
                detailRowHeight={'auto'}
            />
            {showViewPI && <ViewProformaInvoiceData data={viewPIData} viewPI={showViewPI} handleViewForm={handleViewForm} />}
            {(showEditPI && editPIData) && <EditCreatedProformaInvoice editData={editPIData} editPI={showEditPI} successMsg={handleSuccessMsg} error={handleError} handleEditForm={handleEditForm} />}

            <Dialog
                open={formPrintOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={"sm"}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Print Proforma Invoice
                        </Typography>
                        <div >

                            <Button onClick={() => setFormPrintOpen(false)}>
                                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                            </Button>
                        </div>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers >
                    <div className="h-[150px]">
                        <label>Select Option</label>
                        <Select
                            name="printOptions"
                            onChange={handleSelectedPrint}
                            options={[
                                { label: "Print", value: 'Print' },
                                { label: "Print with Stamp", value: 'PrintStamp' },
                                { label: "Print with Sign & stamp", value: 'PrintSignStamp' },
                            ]}
                            styles={customStyles()}
                        />
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button
                    variant="contained"
                    color="warning"
                    size="small"
                    onClick={handlePrintPIOption}
                    >
                        <FuseSvgIcon>heroicons-outline:printer</FuseSvgIcon>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ProformaInvoice